import { render } from "./ArchivedTickets.vue?vue&type=template&id=daecc734&scoped=true"
import script from "./ArchivedTickets.vue?vue&type=script&lang=js"
export * from "./ArchivedTickets.vue?vue&type=script&lang=js"

import "./ArchivedTickets.vue?vue&type=style&index=0&id=daecc734&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daecc734"]])

export default __exports__